import { render, staticRenderFns } from "./HelloWorld.vue?vue&type=template&id=a52aacde&scoped=true&"
import script from "./HelloWorld.vue?vue&type=script&lang=js&"
export * from "./HelloWorld.vue?vue&type=script&lang=js&"
import style0 from "./HelloWorld.vue?vue&type=style&index=0&id=a52aacde&scoped=true&lang=css&"
import style1 from "./HelloWorld.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52aacde",
  null
  
)

export default component.exports